import type { MigrationStrategies } from "./_types/migration-strategies";

export const CONSULTATION_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (_) => null,
  3: (oldDoc) => {
    oldDoc.symptomIds = [];
    return oldDoc;
  },
  4: (oldDoc) => ({
    ...oldDoc,
    isImmunisation: null,
    isPerformedAtOtherClinic: null,
    backdatedTo: null,
  }),
};
